import React from 'react';
import { View } from 'react-native';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components/native';
import Colors from '../colors';
import Icon from '../icon';
const TYPES = {
  square: {
    width: 307,
    height: 307
  },
  rectangle: {
    width: 307,
    height: 194
  },
  portrait: {
    width: 262,
    height: 340
  }
};
const BORDER = {
  topLeft: {
    top: true,
    left: true,
    name: 'chevron-thin-left'
  },
  topRight: {
    top: true,
    right: true,
    name: 'chevron-thin-up'
  },
  bottomRight: {
    bottom: true,
    right: true,
    name: 'chevron-thin-right'
  },
  bottomLeft: {
    bottom: true,
    left: true,
    name: 'chevron-thin-down'
  }
};
const StyledPhoto = styled.View`
  background-color: ${Colors.lightGray300};
  opacity: 0.2;
  flex: 1;
`;
const StyledBorder = styled(Icon.Entypo)`
  position: absolute;
  color: ${Colors.mint400};
  transform: rotate(45deg);
  ${_ref => {
  let {
    top
  } = _ref;
  return top && css`top: -9px`;
}};
  ${_ref2 => {
  let {
    bottom
  } = _ref2;
  return bottom && css`bottom: -9px`;
}};
  ${_ref3 => {
  let {
    left
  } = _ref3;
  return left && css`left: -9px`;
}};
  ${_ref4 => {
  let {
    right
  } = _ref4;
  return right && css`right: -9px`;
}};
`;
export default function BlankPhoto(props) {
  const type = TYPES[props.type || BlankPhoto.defaultProps.type];
  return /*#__PURE__*/React.createElement(View, {
    style: type
  }, /*#__PURE__*/React.createElement(StyledPhoto, null, props.children), Object.keys(BORDER).map(key => {
    const border = BORDER[key];
    return /*#__PURE__*/React.createElement(StyledBorder, {
      key: key,
      name: border.name,
      size: 24,
      top: border.top,
      bottom: border.bottom,
      left: border.left,
      right: border.right
    });
  }));
}
BlankPhoto.propTypes = {
  type: PropTypes.oneOf(Object.keys(TYPES)),
  children: PropTypes.node
};
BlankPhoto.defaultProps = {
  type: 'square',
  children: null
};
//# sourceMappingURL=blank-photo.js.map